/*
 * @Author: ZhangYao
 * @Date: 2021-06-26 10:36:11
 */
export interface AiotResponse<T> {
  code: number
  data: T
  msg: string
}
export interface AiotResponseApi<T> {
  code: number
  getdata: T
}
export interface TempToken {
  tmp_secret_id: string
  tmp_secret_key: string
  session_token: string
  expiration: number
}

function fixNumber(val: number, n: number) {
  const pow = Math.pow(10, n)
  return Math.ceil(val * pow) / pow
}
export function fileLengthFormat(total: number, n: number): string {
  if (total == null || total == undefined) {
    // console.log('fileLengthFormat undefined ')
    return '-'
  }
  let format = '-'
  const len = total / 1024.0
  if (len > 1000) {
    return fileLengthFormat(len, ++n)
  } else {
    switch (n) {
      case 1:
        format = fixNumber(len, 1) + 'KB'
        break
      case 2:
        format = fixNumber(len, 1) + 'MB'
        break
      case 3:
        format = fixNumber(len, 1) + 'GB'
        break
      case 4:
        format = fixNumber(len, 1) + 'TB'
        break
    }
    // console.log('fileLengthFormat: ', format)
    return format
  }
}

export interface updateSpaceItem {
  spaceId: string
  size: number
}

// export interface TempToken {
//   tmp_secret_id: string;
//   tmp_secret_key: string;
//   session_token: string;
//   expiration: number;
// }

// export interface ShareSpaceItem {
//   id: string;
//   label: string;
//   icon: string;
//   space_id: string;
//   space_name: string;
//   total?: string;
//   used?: string;
//   percent_volume?: number;
//   total_volume: number;
//   remain_volume: number;
//   bucket_info: string;
//   status: number;
//   create_time: string;
//   update_time: string;
//   prefix: string;
//   bucket: string;
//   region: string;
//   file_type: number;
// }

// export interface ShareFileItem {
//   file_key: string;
//   cos_file_key: string;
//   url?: string;
//   url_time?: number;
//   icon: string;
//   label: string;
//   creator: string;
//   file_size?: string;
//   fileSize?: number;
//   create_time: string;
//   update_time: string;
//   content_type: string;
//   file_type: number;
//   item_count?: number;
//   previewType?: string;
//   isSelect?: boolean;
//   is_delete?: boolean;
//   space_id: string;
// }
// export interface PreCreateItem {
//   file_key: string;
//   cos_file_key: string;
//   new_file_key?: string;
//   is_duplicate?: boolean;
// }

// export interface TaskItem {
//   /** 上传任务 ID */
//   taskId: string;
//   origin_file_key?: string;
//   file_key: string;
//   cos_file_key: string;
//   label: string;
//   icon?: string;
//   status_text?: string;
//   total_text?: string;
//   loaded_text?: string;
//   /** 上传状态 */
//   state:
//   | "waiting"
//   | "checking"
//   | "uploading"
//   | "error"
//   | "paused"
//   | "success"
//   | "canceled";
//   /** 上传错误信息 */
//   error?: string | Error | { Code: string; Message: string };
//   /** 已上传/下载的字节数，单位 B（字节）  */
//   loaded?: number;
//   /** 要上传/下载的文件的大小，单位 B（字节）  */
//   total?: number;
//   /** 速度，单位 B/s  */
//   speed?: number;
//   /** 进度百分比，范围是 0-1，保留两位小数  */
//   uploadPercent?: number;
//   /** 续传校验进度，范围 0-1，保留两位小数 */
//   hashPercent?: number;
//   hasRestart?: boolean;
// }

// export type ShareItem = ShareFileItem | ShareSpaceItem;

// export interface ShareUserItem {
//   id: string;
//   userName: string;
//   department: string;
//   mobile: string;
// }

// export interface ShareMemberItem {
//   mid: string;
//   uid: string;
//   name: string;
//   department: string;
//   role: number;
//   tel: string;
//   status: number;
//   group_id: string;
// }
